import React from 'react';
import { Typography, LinkButton } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { HeaderModelData } from 'types/model';
import { getShortenRegionName } from 'utils';
import { useTranslation } from 'react-i18next';
import { useRegions, useSideMenuAnalyticsEvent } from 'components/header/hooks';
import { cityPickerLabel, CityPickerRoot, hover, hoveredText } from './styles';

export const DATA_QA = 'CITY_PICKER';

interface CityPickerProps {
  model: HeaderModelData;
  isVisible: boolean;
  onRequestRegionChange: () => void;
}

export const CityPicker = ({ model, isVisible, onRequestRegionChange }: CityPickerProps) => {
  const { t } = useTranslation();

  const { defaultRegion, currentRegion } = useRegions(model);
  const onRegionsClickEvent = useSideMenuAnalyticsEvent('region');
  const formattedRegionName = getShortenRegionName(currentRegion?.regionName || defaultRegion.regionName);

  const handleButtonClick = () => {
    onRegionsClickEvent();
    onRequestRegionChange();
  };

  if (!isVisible) return null;

  return (
    <CityPickerRoot data-qa={DATA_QA}>
      <LinkButton
        size="s"
        withExtraClickZone
        onClick={handleButtonClick}
        iconRight={<ChevronRightIcon />}
        variant="accent"
        data-qa="region-modal-button"
        className={hover}
      >
        <div>
          <Typography variant="caption" color="text-secondary" className={cityPickerLabel}>
            {t('header.main.region')}
          </Typography>
          <span className={hoveredText}>{formattedRegionName}</span>
        </div>
      </LinkButton>
    </CityPickerRoot>
  );
};
